import React from 'react';
import Typography from '@material-ui/core/Typography';

import './QCTabPanelContent.scss';

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

export default function QCTabPanelContent(props: TabPanelProps) {
    const {
        value,
        index,
        children,
    } = props;
    
    if (value === index && children) {
        return (
            <div className="tab-panel-content">
                <Typography component="span">{children}</Typography>
            </div>
        );
    }
    
    return null;
}

QCTabPanelContent.defaultProps = {
    children: null,
};
